import { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useMenuState } from "@szhsin/react-menu";

import ContextMenu from "components/context-menu/context-menu.component";
import { ReactComponent as FolderAdd } from "assets/folder/folder_add.svg";
import { ReactComponent as FolderEmpty } from "assets/folder/folder_empty.svg";
import { ReactComponent as FolderFilled } from "assets/folder/folder_filled.svg";

import { FolderContext } from "src/contexts/folder.context";

import "./folder.style.scss";
import ReactTextareaAutosize from "react-textarea-autosize";

const Folder = ({ fileName, isEmpty, addButton = false, size = "medium", folderId = 0 }) => {
	const { getInside, addFolder, renameFolder, deleteFolder } = useContext(FolderContext);
	const [menuProps, toggleMenu] = useMenuState();
	const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });

	const [updatedFolderName, setUpdatedFolderName] = useState(fileName);

	const [isEditable, setIsEditable] = useState(false);

	const inputRef = useRef();

	useEffect(() => {
		if (isEditable && inputRef) {
			inputRef.current.focus();
		}
	}, [isEditable]);

	const contextMenuList = useMemo(
		() => [
			{
				label: "Rename",
				onClick: () => {
					setIsEditable(true);
				},
			},
			{
				label: "Delete",
				onClick: () => {
					deleteFolder(fileName);
				},
			},
		],
		[fileName, deleteFolder]
	);

	const handleClick = () => {
		if (addButton) {
			// TODO: add add new folder
			addFolder("New Folder");
			return;
		}
		getInside(fileName);
	};

	const handleChangeName = ({ target }) => {
		const { value } = target;

		setUpdatedFolderName(value);
	};

	const handleSubmitRename = () => {
		if (updatedFolderName.length === 0) {
			handleCancelRename();
			return;
		}

		setIsEditable(false);
		renameFolder(fileName, updatedFolderName, folderId);
	};

	const handleCancelRename = () => {
		setUpdatedFolderName(fileName);
		setIsEditable(false);
	};

	return (
		<Fragment>
			<div className={`folder_container ${size}`}>
				<span
					onContextMenu={(e) => {
						e.preventDefault();
						setAnchorPoint({ x: e.clientX, y: e.clientY });
						toggleMenu(true);
					}}
					onClick={handleClick}
				>
					{addButton ? (
						<FolderAdd className={`folder`} />
					) : isEmpty ? (
						<FolderEmpty className={`folder`} />
					) : (
						<FolderFilled className={`folder`} />
					)}
				</span>
				<ReactTextareaAutosize
					ref={inputRef}
					className=" folder_name unselectable"
					maxRows={3}
					value={updatedFolderName}
					onChange={handleChangeName}
					onKeyDown={({ code }) => {
						if (code === "Enter") handleSubmitRename();
						if (code === "Escape") handleCancelRename();
					}}
					onBlur={handleCancelRename}
					disabled={!isEditable}
				/>
			</div>

			<ContextMenu
				list={contextMenuList}
				menuProps={menuProps}
				toggleMenu={toggleMenu}
				anchorPoint={anchorPoint}
			/>
		</Fragment>
	);
};

export default Folder;
